<template>
  <b-tag class="is-info" ellipsis>{{ tag.label }}</b-tag>
</template>

<script>
export default {
  name: "TagItem",
  props: {
    tag: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
